import logger from "../utils/logger";

export async function getLcaMasterByUuid(uuid: string) {
    try {
        let _q = `SELECT * FROM lca_master WHERE uuid = '${uuid}' ORDER BY effective_dt DESC`;
        const response = await fetch(process.env.REACT_APP_API_URL + "/dynamic", {
            method: "post",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
                query: _q,
                params: ["lca_master"],
            }),
        });
        return await response.json();
    } catch (error) {
        logger.error("getLcaMasterByUuid failed", { uuid }, error);
        return [];
    }
}

export async function saveLcaMaster(data: any) {
    try {
        const rawResponse = await fetch(process.env.REACT_APP_API_URL + "/api/lca_master", {
            method: "POST",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
            },
            body: JSON.stringify(data),
        });
        return await rawResponse.json();
    } catch (error) {
        logger.error("saveLcaMaster failed", { data }, error);
        return null;
    }
}

export async function updateLcaMaster(data: any) {
    try {
        const rawResponse = await fetch(process.env.REACT_APP_API_URL + "/api/lca_master", {
            method: "PUT",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
            },
            body: JSON.stringify(data),
        });
        return await rawResponse.json();
    } catch (error) {
        logger.error("updateLcaMaster failed", { data }, error);
        return null;
    }
}

export async function deleteLcaMaster(id: number) {
    try {
        let _q = `DELETE FROM lca_master WHERE id = ${id}`;
        const response = await fetch(process.env.REACT_APP_API_URL + "/dynamic", {
            method: "post",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
                query: _q,
                params: ["lca_master"],
            }),
        });
        return await response.json();
    } catch (error) {
        logger.error("deleteLcaMaster failed", { id }, error);
        return [];
    }
}
